import {proxyBE} from './common';

export const qualificationService = {
  loadAllCompetitionClass() {
    return proxyBE.get("qualifications/competitionClass");
  },

  loadAllCompetitionClass2026() {
    return proxyBE.get("qualifications/competitionClass/2026");
  },

  loadCompetitionClassByQT(idQualification) {
    return proxyBE.get(`qualifications/competitionClass/idQT/${idQualification}`);
  },

  loadCompetitionClassByQT2026(idQualification) {
    return proxyBE.get(`qualifications/competitionClass/2026/${idQualification}`);
  },

    loadCompetitionClassByCCO(idCompetitionClassOld) {        
        return proxyBE.get(`qualifications/competitionClass/idCCO/${idCompetitionClassOld}`);        
    },

  loadCompetitionClassByCCO2026(idCompetitionClassOld, codeYear) {
    return proxyBE.get(`qualifications/competitionClass/2026/${codeYear}/${idCompetitionClassOld}`);
  },

  loadAllCompetitionClassOld() {
    return proxyBE.get("qualifications/competitionClassOld");
  },

  loadAllCompetitionClassOld2026() {
    return proxyBE.get("qualifications/competitionClassOld/2026");
  },

  loadCompetitionClassOld(idCompetitionClassOld){
        return proxyBE.get(`qualifications/competitionClassOld/${idCompetitionClassOld}`);  
    },

  loadCompetitionClassOldByCC(idCompetitionClass) {
    return proxyBE.get(`qualifications/competitionClassOld/idCCN/${idCompetitionClass}`);
  },

  loadCompetitionClassOldByCC2026(idCompetitionClass) {
    return proxyBE.get(`qualifications/competitionClassOld/2026/${idCompetitionClass}`);
  },

    loadAllQualificationTitle() {        
        return proxyBE.get('qualifications/title');        
    },

    loadQualificationTitle(idCompetitionClass){
        return proxyBE.get(`qualifications/title/${idCompetitionClass}`);  
    },

  loadQualificationTitle2026(idCompetitionClass) {
    return proxyBE.get(`qualifications/title/2026/${idCompetitionClass}`);
  },

  getSchoolTypeCode() {
    return proxyBE.get(`qualifications/schoolTypeCode`);
  },
};
